module.exports = __webpack_public_path__ + "img/安防配件.a73a8ec7.jpg";